<script lang="ts" setup>
const image = ref<HTMLElement | null>(null)
const targetIsVisible = useElementVisibility(image)
const showImage = ref(false)
watch(targetIsVisible, (val) => {
  if (val) {
    showImage.value = true
  }
})
withDefaults(defineProps<{ src?: string, alt?: string }>(), { src: '/images/', alt: '' })
</script>

<template>
  <div ref="image" :class="[showImage ? 'opacity-100 duration-500' : 'opacity-0']">
    <NuxtPicture format="webp,png" :src="src" :alt="alt" :img-attrs="{ class: 'h-full w-full object-cover' }" />
  </div>
</template>
